<template>
  <div>
    
    <h3>{{ record.product ? record.product.product_name_en : '' }}</h3>

    <div v-if="isStockInShow">
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.stockIn') }}
      </h6>
      <StockIn :value="record.stock_in" />
    </div>
		<div>
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">{{ $t('productProfile.statusAndLocation') }}</h6>
			<StatusLocation :value="record" />
    </div>
    <div v-if="isReplacementShow">
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.replacementHistory') }}
      </h6>
      <template v-for="(r, index) in record.replacements">
        <ReplacementSerialHistory :value="r" :key="index" />
        <hr />
      </template>
    </div>
    <!-- <h4 class="ts-text-gray-400 ts-text-center" v-else>{{ $t('productProfile.notFound') }}</h4> -->
  </div>
</template>

<script>
import ReplacementSerialHistory from './replacement-serial-history.vue'
import StatusLocation from './status-location.vue'
import StockIn from './stock-in.vue'
export default {
  name: 'viewSerialHistory',
  props: ['record'],
  components: {
    ReplacementSerialHistory,
    StatusLocation,
    StockIn,
  },
  computed: {
    isReplacementShow() {
      if (this.record.replacements || this.record.replacements != undefined) {
        return this.record.replacements.length
      }
    },
    isStockInShow() {
      if (this.record.stock_in || this.record.stock_in != undefined) {
        return !_.isEmpty(this.record.stock_in)
      }
    },
  },
}
</script>